const projects = [
  {
    name: 'Amok: The Darkest Phase',
    description: 'Original score for Amok: The Darkest Phase, a Malayalam action crime thriller short film. Won Best Music Director Award (Malayalam category) at the Stoned Monkey International Film Awards for Shorts 2019.',
    url: 'https://www.youtube.com/watch?v=GZIeB2N_F5o',
    label: 'watch on youtube →',
    tag: 'music',
    image: 'https://img.youtube.com/vi/GZIeB2N_F5o/maxresdefault.jpg',
    tools: [],
  },
  {
    name: 'Ananda Ragam',
    description: 'A semi-classical composition with electronic elements. Performed by Vimaljith Vijayan (vocals), Adithi Shankar (veena), and Vivek Vijayan (guitar).',
    url: 'https://vivekvjyn.bandcamp.com/track/nanda-r-gamo',
    label: 'listen on bandcamp →',
    tag: 'music',
    image: 'https://f4.bcbits.com/img/a3208278316_16.jpg',
    tools: [],
  },
  {
    name: 'CompIAM',
    description: 'Computational analysis of Indian Art Music, a repository of datasets, tools, and models for Carnatic and Hindustani music. Contributions: TCN Carnatic and BeatThis Carnatic beat tracking modules.',
    url: 'https://mtg.github.io/compIAM/',
    label: 'view documentation →',
    tag: 'library',
    image: 'https://s0.wp.com/mshots/v1/https://mtg.github.io/compIAM/?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
      { name: 'PyTorch', icon: 'pytorch' },
    ],
  },
  {
    name: 'Contrivance',
    description: "Promotional song for IHRD Tharang'23, a National Level Techno-Cultural-Entrepreneurial event organized by the Institute of Human Resources Development (IHRD). Performed by Nived Vilson P (male vocals) and Esther Vargese (female vocals).",
    url: 'https://www.youtube.com/watch?v=0JqvaH6eM24',
    label: 'watch on youtube →',
    tag: 'music',
    image: 'https://img.youtube.com/vi/0JqvaH6eM24/maxresdefault.jpg',
    tools: [
      { name: 'After Effects', icon: 'aftereffects' },
      { name: 'Photoshop', icon: 'photoshop' },
      { name: 'Premiere Pro', icon: 'premierepro' },
    ],
  },
  {
    name: 'ContextGRU',
    description: 'Leveraging Melodic Context for Improved Svara Representation. Presented at CMMR (17th International Conference on Computer Music Multidisciplinary Research) 2025.',
    url: 'https://doi.org/10.5281/zenodo.17497901',
    label: 'read paper →',
    tag: 'research',
    image: 'https://raw.githubusercontent.com/thomasgnuttall/ContextGRU/main/model.png',
    lightImage: true,
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
      { name: 'PyTorch', icon: 'pytorch' },
    ],
  },
  {
    name: 'GeoSynth',
    description: 'Sonification of geolocations using an autoencoder, with data collected using Freesound API.',
    url: 'https://geosynth.vivekvjyn.xyz/',
    label: 'visit website →',
    tag: 'website',
    image: 'https://s0.wp.com/mshots/v1/https://geosynth.vivekvjyn.xyz/?w=600',
    tools: [
      { name: 'CSS', icon: 'css3' },
      { name: 'Docker', icon: 'docker' },
      { name: 'Flask', icon: 'flask' },
      { name: 'Git', icon: 'git' },
      { name: 'HTML', icon: 'html5' },
      { name: 'JavaScript', icon: 'javascript' },
      { name: 'Jupyter', icon: 'jupyter' },
      { name: 'Python', icon: 'python' },
      { name: 'TensorFlow', icon: 'tensorflow' },
    ],
  },
  {
    name: 'Intellectual Gate',
    description: 'Plugin that lets you remove drum bleed without compromising punch.',
    url: 'https://github.com/CoconutAudio/Intellectual-Gate/releases/tag/v1.0.0',
    label: 'view release →',
    tag: 'vst',
    image: 'https://raw.githubusercontent.com/CoconutAudio/Intellectual-Gate/main/screenshot.png',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'CMake', icon: 'cmake' },
      { name: 'Figma', icon: 'figma' },
      { name: 'Git', icon: 'git' },
    ],
  },
  {
    name: 'Markrethe',
    description: 'Python package for logging your experiments to a Markdown file.',
    url: 'https://markrethe.readthedocs.io/en/latest/',
    label: 'view documentation →',
    tag: 'library',
    image: 'https://s0.wp.com/mshots/v1/https://markrethe.readthedocs.io/en/latest/?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
    ],
  },
  {
    name: 'MIDI2Svara',
    description: 'Plugin that synthesizes Carnatic gamakas from plain MIDI notes, covering ragas such as Abhogi, Begada, Kalyani, Mohanam, Sahana, Saveri, and Sri.',
    url: 'https://github.com/CoconutAudio/MIDI2Svara',
    label: 'view on github →',
    tag: 'vst',
    image: 'https://raw.githubusercontent.com/CoconutAudio/MIDI2Svara/main/screenshot.png',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'CMake', icon: 'cmake' },
      { name: 'Git', icon: 'git' },
    ],
  },
  {
    name: 'Mirdata',
    description: 'Open-source Python library for loading and exploring music/audio research datasets. Contributions: dataset loaders for Saraga Audiovisual and IAM Melodic Similarity datasets.',
    url: 'https://mirdata.readthedocs.io/en/latest/',
    label: 'view documentation →',
    tag: 'library',
    image: 'https://s0.wp.com/mshots/v1/https://mirdata.readthedocs.io/en/latest/?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
    ],
  },
  {
    name: 'Multiply and Replenish',
    description: 'Neural vocal pitch editor that lets you create multiple instances of a vocal take and manipulate each differently to create realistic harmonies. Supports ARA.',
    url: 'https://github.com/CoconutAudio/Multiply-and-Replenish',
    label: 'view on github →',
    tag: 'vst',
    image: 'https://raw.githubusercontent.com/CoconutAudio/Multiply-and-Replenish/main/screenshot.jpeg',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'CMake', icon: 'cmake' },
      { name: 'Git', icon: 'git' },
      { name: 'PyTorch', icon: 'pytorch' },
    ],
  },
  {
    name: 'Old Guitarist',
    description: 'Physically modeled virtual guitar plugin using finite difference method.',
    url: 'https://github.com/vivekvjyn/Old-Guitarist',
    label: 'view on github →',
    tag: 'vst',
    image: 'https://github.com/vivekvjyn/Old-Guitarist/raw/main/screenshot.png',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'CMake', icon: 'cmake' },
      { name: 'Figma', icon: 'figma' },
      { name: 'Git', icon: 'git' },
    ],
  },
  {
    name: 'Pulp Fiction',
    description: 'Multi FX rack plugin with four slots, allowing users to choose audio effects for each slot from a drop-down menu.',
    url: 'https://github.com/CoconutAudio/Pulp-Fiction/releases/tag/tremolo',
    label: 'view release →',
    tag: 'vst',
    image: 'https://raw.githubusercontent.com/CoconutAudio/Pulp-Fiction/main/screenshot.png',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'Figma', icon: 'figma' },
      { name: 'Git', icon: 'git' },
    ],
  },
  {
    name: 'RISE',
    description: 'Raga Independent Svara Encoder. Self supervised learning for raga independent svara representation, aimed at Carnatic music transcription, performance analysis, and melodic pattern recognition.',
    url: 'https://doi.org/10.1145/3815723.3815730',
    label: 'read paper →',
    tag: 'research',
    image: 'https://raw.githubusercontent.com/MTG/RISE/main/.github/images/simclr.png',
    lightImage: true,
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
      { name: 'PyTorch', icon: 'pytorch' },
    ],
  },
  {
    name: 'Secret of Kalinga',
    description: 'Official trailer soundtrack for Secret of Kalinga.',
    url: 'https://www.youtube.com/watch?v=PYM2cBMIhx4',
    label: 'watch on youtube →',
    tag: 'music',
    image: 'https://img.youtube.com/vi/PYM2cBMIhx4/maxresdefault.jpg',
    tools: [],
  },
  {
    name: 'Strawberry Fields',
    description: 'Query-by-humming for Indian art music. Hum a melody into your microphone and find the matching piece.',
    url: 'https://strawberryfields.vivekvjyn.xyz/',
    label: 'visit website →',
    tag: 'website',
    image: 'https://s0.wp.com/mshots/v1/https://strawberryfields.vivekvjyn.xyz/?w=600',
    tools: [
      { name: 'CSS', icon: 'css3' },
      { name: 'Flask', icon: 'flask' },
      { name: 'Git', icon: 'git' },
      { name: 'HTML', icon: 'html5' },
      { name: 'JavaScript', icon: 'javascript' },
      { name: 'Jupyter', icon: 'jupyter' },
      { name: 'Python', icon: 'python' },
      { name: 'PostgreSQL', icon: 'postgresql' },
    ],
  },
  {
    name: 'Sound of Music',
    description: 'Sound of Music is a multiband bit crusher plugin with adjustable bands for audio control and manipulation.',
    url: 'https://github.com/CoconutAudio/Sound-of-Music/releases/tag/v1.0.0',
    label: 'view release →',
    tag: 'vst',
    image: 'https://raw.githubusercontent.com/CoconutAudio/Sound-of-Music/main/screenshot.png',
    tools: [
      { name: 'C++', icon: 'cplusplus' },
      { name: 'CMake', icon: 'cmake' },
      { name: 'Figma', icon: 'figma' },
      { name: 'Git', icon: 'git' },
    ],
  },
  {
    name: 'Svaras in Space',
    description: "Master's thesis for the Master in Sound and Music Computing at Universitat Pompeu Fabra on svara representation learning.",
    url: 'https://zenodo.org/records/23192675',
    label: 'read thesis →',
    tag: 'research',
    image: 'https://zenodo.org/api/iiif/record:23192675:TFM-2026-Vivek-Vijayan.pdf/full/%5E750,/0/default.jpg',
    lightImage: true,
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Python', icon: 'python' },
      { name: 'PyTorch', icon: 'pytorch' },
    ],
  },
  {
    name: 'TinkerHub CEC Website',
    description: 'Official website of TinkerHub CEC, the TinkerHub chapter at College of Engineering, Chengannur.',
    url: 'https://tinkerhub-cec-website.vercel.app/',
    label: 'visit website →',
    tag: 'website',
    image: 'https://s0.wp.com/mshots/v1/https://tinkerhub-cec-website.vercel.app/?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'JavaScript', icon: 'javascript' },
      { name: 'React', icon: 'react' },
    ],
  },
  {
    name: 'This Website',
    description: 'The website you are staring at.',
    url: 'https://vivekvjyn.xyz',
    label: 'visit website →',
    tag: 'website',
    image: 'https://s0.wp.com/mshots/v1/https://vivekvjyn.xyz/?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'JavaScript', icon: 'javascript' },
      { name: 'React', icon: 'react' },
      { name: 'Tailwind CSS', icon: 'tailwindcss' },
    ],
  },
  {
    name: 'Tutorial on Computational Methods for Supporting Corpus-Based Research on Indian Art Music',
    description: 'ISMIR 2022 tutorial notebooks, a starting point for researchers looking to get started with computational analysis of Carnatic and Hindustani music. Contributions: notebooks for Saraga Audiovisual dataset usage and TCN Carnatic module usage.',
    url: 'https://mtg.github.io/IAM-tutorial-ismir22/landing.html',
    label: 'visit website →',
    tag: 'website',
    image: 'https://s0.wp.com/mshots/v1/https://mtg.github.io/IAM-tutorial-ismir22/landing.html?w=600',
    tools: [
      { name: 'Git', icon: 'git' },
      { name: 'Jupyter', icon: 'jupyter' },
      { name: 'Python', icon: 'python' },
    ],
  },
];

export default projects;
